import React from 'react'
import {createRoot} from 'react-dom/client'

import App from './components/App'
import {LoadIntl} from './services/intl'

import 'reset-css'

import './styles/index.scss'
import 'core-js/features/math/clamp'
import 'core-js/features/array/with'
import 'core-js/features/array/to-reversed'
import 'core-js/features/array/to-sorted'
import 'core-js/features/array/to-spliced'
import 'core-js/features/object/group-by'

import type {} from './reactTypeAugmention/cssCustomProperties'

require.context('./assets/icons/', false, /\.svg$/)

const rootElement = document.querySelector('#root') as Element
const root = createRoot(rootElement)

root.render(
    <React.StrictMode>
        <LoadIntl>
            <App/>
        </LoadIntl>
    </React.StrictMode>
)

